export default __webpack_public_path__ + "static/media/grupos gerais jersu indica.157ca1dd.png";